import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Document, Page } from "react-pdf";
import { Loader, Toastr } from "@revvsales/components";

// Components Imports
import { AmplitudeUtils } from "../../../utils";
import { EVENTS } from "../../../constants";
// Actions Imports

// Service Imports
import { exportDocument } from "../../../actions/QuoteDocuments/services";

// Internal Imports
import { getExportContent } from "../../../utils/documentUtils";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

class PreviewDocument extends Component {
  state = {
    isLoading: true,
    pdfFileForPreview: null,
    numPages: null,
    pageNumber: 1,
  };

  componentDidMount() {
    this._previewDocument();
    amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_PREVIEW_CLICKED);
  }

  _previewDocument = () => {
    const { document, components, html } = this.props;
    const previewContent = getExportContent(document, components, html);
    previewContent.event = "preview";
    this._openPreviewModal(previewContent);
  };

  _openPreviewModal = previewContent => {
    exportDocument("pdf", previewContent)
      .then(response => {
        const docMIMEType = "application/pdf";
        const pdfFileForPreview = new Blob([response], {
          type: docMIMEType,
        });
        this.setState({
          pdfFileForPreview,
          isLoading: false,
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isLoading: false,
        });
        this._closePreviewModal();
        Toastr.showToastr({
          type: "failure",
          message: "Error while fetching the document preview",
          timeout: 3000,
        });
      });
  };

  _closePreviewModal = () => {
    this.setState({ pdfFileForPreview: null });
    this.props.togglePopUp("showPreviewModal", false);
  };

  _onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  render() {
    if (this.state.isLoading) {
      return (
        <Loader
          className="saving-document"
          label="Loading Preview"
          fullScreen
          theme="dark"
        />
      );
    }
    const { pageNumber, numPages } = this.state;
    const { docNo, name } = this.props.document;
    return (
      <Modal
        classNames={{ modal: "doc-preview-modal" }}
        open
        onClose={this._closePreviewModal}
        showCloseIcon={false}
        closeOnOverlayClick={false}
        center>
        <div className="download-btn-bar">
          <div className="download-bar-title">
            <span className="download-bar-text">
              {name}&nbsp;({docNo})
            </span>
          </div>
          <div
            className="download-bar-back"
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={this._closePreviewModal}>
            {/* <i className="">
                <FontAwesomeIcon icon={["far", "angle-left"]} />
              </i> */}
            <i
              className="documenttemplatepreview-close-icon"
              onKeyPress={
                () => null // onClick={() => togglePreview(false)}
              }
              role="button"
              tabIndex="0">
              <FontAwesomeIcon icon={["far", "times"]} />
            </i>
          </div>
        </div>
        <Document
          file={this.state.pdfFileForPreview}
          onLoadSuccess={this._onDocumentLoadSuccess}
          className="doc-preview-document">
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              className="doc-preview-page-break"
            />
          ))}
        </Document>
        <p>
          Page {pageNumber} of {numPages}
        </p>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document, components } = state.DocumentStore;

  return {
    components,
    document,
  };
};

export default connect(
  mapStateToProps,
  null,
)(PreviewDocument);



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbarBtns/PreviewDocument.js